import { createApi } from "@reduxjs/toolkit/query/react";
import type { GetAdminDiagnosticsResponse } from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";

export const adminDiagnosticsApi = createApi({
    reducerPath: "adminDiagnosticsApi",
    baseQuery: baseQueryAdminWithAuth,
    endpoints: builder => ({
        getAdminDiagnostics: builder.query<GetAdminDiagnosticsResponse, void>({
            query: () => "diagnostics"
        })
    })
});

export const { useGetAdminDiagnosticsQuery } = adminDiagnosticsApi;
